import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";
import LoginForm from "../components/LoginForm";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

export default function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);

const [darkMode, setDarkMode] = useState(() => {
const saved = localStorage.getItem("theme");
return saved === "dark";
});

React.useEffect(() => {
if (darkMode) {
document.documentElement.classList.add("dark");
localStorage.setItem("theme", "dark");
} else {
document.documentElement.classList.remove("dark");
localStorage.setItem("theme", "light");
}
}, [darkMode]);

  const handleLogin = async (data) => {
    setLoading(true);

    try {
      const payload = {
        identifier: data.identifier,
        password: data.password,
      };

      const res = await axios.post(`${API_BASE}/api/auth/login`, payload);
      const { token, user } = res.data;

      if (!token || !user) {
        throw new Error("Invalid response from server");
      }

      // ✅ RESTORE ORIGINAL STRUCTURE (flat user + token)
      const updatedUser = {
        ...user,
        token,
        subscriptionExpiresAt: user.subscriptionExpiresAt || null,
        purchasedPlans: user.purchasedPlans || [],
      };

      const expiresAt =

data.rememberMe

?

Date.now()

+

30 *

24 *

60 *

60 *

1000

:

Date.now()

+

12 *

60 *

60 *

1000;

const finalUser = {

...updatedUser,

loginExpiresAt:

expiresAt,

};

localStorage.setItem(

"user",

JSON.stringify(
finalUser
)

);
      window.dispatchEvent(new Event("userUpdated"));

      toast.success("✅ Login successful!");

      // ✅ Role-based redirect
      if (user.role === "admin") {
        navigate("/admin/overview");
      } else if (user.role === "user") {
        navigate("/dashboard");
      } else {
        toast.error("Unknown user role. Please contact support.");
      }

      return { success: true };
    } catch (err) {
      console.error("❌ Login error:", err.response?.data || err.message);

      const backendMsg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "";

      let userMsg = "Login failed. Please check your credentials.";
      if (backendMsg.toLowerCase().includes("password")) {
        userMsg = "Incorrect password. Please try again.";
      } else if (backendMsg.toLowerCase().includes("email")) {
        userMsg = "No account found with this email.";
      } else if (backendMsg.toLowerCase().includes("username")) {
        userMsg = "Username not recognized. Please try again.";
      } else if (err?.response?.status === 401) {
        userMsg = "Incorrect username or password.";
      } else if (err?.response?.status === 404) {
        userMsg = "Account not found. Please check your details.";
      } else if (!err.response) {
        userMsg =
          "Network or server issue. Please check your connection or try again later.";
      }

      throw new Error(userMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
<div className="
min-h-screen
relative
overflow-hidden

bg-gradient-to-br
from-yellow-50
via-white
to-orange-50

dark:from-gray-950
dark:via-gray-900
dark:to-black

transition-colors
duration-700
">

{/* Background glow */}
<div className="
absolute
top-[-150px]
left-[-100px]

w-[450px]
h-[450px]

bg-yellow-300/20
blur-3xl
rounded-full
pointer-events-none
"/>

<div className="
absolute
bottom-[-150px]
right-[-100px]

w-[400px]
h-[400px]

bg-blue-500/10
blur-3xl
rounded-full
pointer-events-none
"/>

<div className="
relative
z-10

min-h-screen

grid
lg:grid-cols-2
">

{/* LEFT SIDE */}
<div className="
hidden
lg:flex

flex-col
justify-center

px-20
">

<div className="max-w-xl">

<div className="
inline-flex
items-center
gap-3
mb-8
">

<img
src="/logo.png"
alt="UPSC Journey"
className="w-16"
/>

<h1 className="
text-5xl
font-black

text-gray-900
dark:text-yellow-50
">
UPSC Journey
</h1>

</div>

<h2 className="
text-5xl
font-black
leading-tight

text-gray-900
dark:text-yellow-50
">
Your complete
UPSC preparation
system.
</h2>

<p className="
mt-8
text-xl
leading-relaxed

text-gray-700
dark:text-gray-200
">
Editorials, Notes, MCQs,
Answer Writing and Tests —
all connected in one workflow.
</p>

<div
className="
mt-10
space-y-5

text-lg
font-medium

text-gray-800
dark:text-yellow-50

[&_div]:flex
[&_div]:items-center
[&_div]:gap-3

[&_div]:rounded-xl
[&_div]:px-4
[&_div]:py-3

dark:[&_div]:bg-white/5
dark:[&_div]:backdrop-blur-sm
dark:[&_div]:border
dark:[&_div]:border-white/10
"
>

<div>✓ Daily editorial analysis</div>

<div>✓ UPSC-level MCQ practice</div>

<div>✓ Integrated Prelims + Mains</div>

<div>✓ Performance tracking</div>

</div>

</div>

</div>

{/* RIGHT SIDE */}
<div className="
flex
items-center
justify-center

px-5
py-10
">

<div
className="
w-full
max-w-md

rounded-[32px]

bg-white/85
dark:bg-gray-900/90

backdrop-blur-2xl

border
dark:border-yellow-400/15

shadow-[0_20px_70px_rgba(0,0,0,0.12)]

p-8
md:p-10
"
>

<div className="relative mb-8 text-center">

<button
onClick={() => setDarkMode(!darkMode)}
className="
absolute
top-0
right-0

w-11
h-11

rounded-2xl

bg-gray-100
dark:bg-gray-800

hover:scale-105

transition

flex
items-center
justify-center
"
>

{darkMode ? (

<svg
xmlns="http://www.w3.org/2000/svg"
className="w-6 h-6 text-yellow-400"
fill="none"
viewBox="0 0 24 24"
stroke="currentColor"
>
<path
strokeLinecap="round"
strokeLinejoin="round"
strokeWidth={2}
d="M12 3v1m0 16v1m8-9h1M3 12H2m15.364 6.364l.707.707M5.636 5.636l-.707-.707M18.364 5.636l.707-.707M5.636 18.364l-.707.707M12 8a4 4 0 100 8 4 4 0 000-8z"
/>
</svg>

) : (

<svg
xmlns="http://www.w3.org/2000/svg"
className="w-6 h-6 text-gray-700"
fill="none"
viewBox="0 0 24 24"
stroke="currentColor"
>
<path
strokeLinecap="round"
strokeLinejoin="round"
strokeWidth={2}
d="M20.354 15.354A9 9 0 018.646 3.646a9 9 0 1011.708 11.708z"
/>
</svg>

)}

</button>

<img
src="/logo.png"
alt=""
className="
w-20
mx-auto
mb-4
"
/>

<h2 className="
text-3xl
font-black

text-gray-900
dark:text-yellow-50
">
Welcome Back
</h2>

<p className="
mt-2

text-gray-500
dark:text-gray-400
">
Continue your preparation journey
</p>

</div>

<LoginForm
onSubmit={(data)=>
handleLogin({
...data,
rememberMe
})
}
loading={loading}
/>

<label
className="
mt-4
flex
items-center
gap-3
text-sm
text-gray-600
dark:text-gray-300
"
>

<input
type="checkbox"

checked={
rememberMe
}

onChange={
(e)=>
setRememberMe(
e.target.checked
)
}

className="
w-4
h-4
accent-blue-600
"
/>

Keep me logged in
for 30 days

</label>

<button
onClick={() => navigate("/")}

className="
mt-6
w-full

py-3

rounded-2xl

bg-gray-100
hover:bg-gray-200

dark:bg-gray-800
dark:hover:bg-gray-700

border
border-gray-300
dark:border-yellow-400/20

text-gray-900
dark:text-yellow-100

font-semibold

shadow-md

hover:shadow-lg

transition-all
duration-300
"
>
← Back to Homepage
</button>

</div>

</div>

</div>

<footer
className="
absolute
bottom-5

left-1/2
-translate-x-1/2

text-sm

text-gray-500
dark:text-gray-400
"
>
© {new Date().getFullYear()} UPSC Journey
</footer>

</div>
);
}
